import { appendSanitizedQueryString } from "@/utils/form/queryParams";

/**
 * Helper function to construct query filters with pagination
 * Handles the proper concatenation of filter parameters and pagination query
 * @param {string} filter - Filter string from useGetParams (starts with ? or empty)
 * @param {string} paginationQuery - Pagination query from useLocalPaginationHelper (may start with &, ?, or neither)
 * @returns {string} Properly formatted query string starting with ?
 * @example
 * // With filters
 * constructFiltersQuery("?search=test", "&limit=25&offset=0")
 * // Returns: "?search=test&limit=25&offset=0"
 *
 * // Without filters - paginationQuery starts with &
 * constructFiltersQuery("", "&limit=25&offset=0")
 * // Returns: "?limit=25&offset=0"
 *
 * // Without filters - paginationQuery starts with ?
 * constructFiltersQuery("", "?limit=25&offset=0")
 * // Returns: "?limit=25&offset=0"
 *
 * // Without filters - paginationQuery has no prefix
 * constructFiltersQuery("", "limit=25&offset=0")
 * // Returns: "?limit=25&offset=0"
 */
export const constructFiltersQuery = (
  filter: string,
  paginationQuery: string,
): string => {
  const params = new URLSearchParams();

  appendSanitizedQueryString(params, filter);
  appendSanitizedQueryString(params, paginationQuery);

  const query = params.toString();

  return query ? `?${query}` : "";
};
